import React from 'react';

import { Button, Dialog, DownloadOverlayProps } from '@hcs/design-system';

import styles from './DownloadOverlay.module.css';

export const DownloadOverlay = ({
  dialogProps,
  onClickCta,
}: DownloadOverlayProps) => {
  return (
    <Dialog
      {...dialogProps}
      title="Spreadsheet Guidelines"
      dataHcName="spreadsheet-guidelines-dialog"
      active={dialogProps?.active}
      onClose={dialogProps?.onClose}
      type="auto"
      width={700}
    >
      <>
        <h4>A few helpful tips for working with the sample spreadsheet:</h4>
        <div className={styles.DownloadOverlayBody}>
          1. Don't change the values in the header of the file.
        </div>
        <div className={styles.DownloadOverlayBody}>
          2. State should be the 2 letter state abbreviation
        </div>
        <div className={styles.DownloadOverlayBody}>
          3. Zipcode should be the standard 5 character zip.
        </div>
        <div className={styles.DownloadOverlayBody}>
          4. Use UTC and the format 2025-02-20T01:45:00Z for all date/time
          entries for "Agile Insight Effective Date" reports.
        </div>
      </>
      <Button
        dataHcName="recalculate-bill"
        className={styles.DownloadOverlayButton}
        label="Continue"
        onClick={onClickCta}
      />
    </Dialog>
  );
};
